import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ifom',
  templateUrl: './ifom.component.html',
  styleUrls: ['./ifom.component.css']
})
export class IfomComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
